lastPaidPrice